import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { FriendToUser } from '../../../models/FriendToUser'
import { Inventory } from '../../../models/Inventory'
import { axiosGet, axiosPost } from '../../Common/Axios'
import Waiting from '../../Common/Waiting'
import MenteeInventoryGrid from '../Inventory/MenteeInventoryGrid'
import { User } from '../../../models/User'
import { InventoryReplyFormValues } from '../../Popup/InventoryReplyForm'
import { RootState, useAppSelector } from '../../../store'
import { TestQuestionAnswerCase } from '../../../models/TestQuestionAnswerCase'
import { ExpandedProps, SmallLightGrayButton } from '../../Layout/CommonStyle'

type CategoryProps = {
  current?: string
}

type Props = {
  friend: FriendToUser | undefined
}

function Main(props: Props) {
  const [inventories, setInventories] = useState<Inventory[]>([])
  const [testQuestionAnswerCase, setTestQuestionAnswerCase] = useState<
    TestQuestionAnswerCase | undefined
  >(undefined)
  const [waiting, setWaiting] = useState(false)
  const [isExpanded, setIsExpanded] = useState<boolean>(false)

  const me = useAppSelector((state: RootState) => state.user.me)

  useEffect(() => {
    async function loadInventories() {
      setWaiting(true)
      const payload = { userId: props.friend?.friend.id ?? 0 }
      const data = await axiosPost(
        '/api/inventory/get_friend_inventories',
        payload
      )
      setInventories(data)
      setWaiting(false)
    }

    async function loadTestQuestionAnswerCase(id: number) {
      if (id == 0) return
      const result = await axiosGet(`/api/test/get_test_answer_case/${id}/1`)

      const testQuestionAnswerCase = result.data
      console.log(
        'id',
        id,
        'testQuestionAnswerCase',
        testQuestionAnswerCase,
        'result',
        result
      )
      setTestQuestionAnswerCase(testQuestionAnswerCase)
    }

    loadInventories()
    loadTestQuestionAnswerCase(props.friend?.friend.id ?? 0)
  }, [props.friend])

  return (
    <Container>
      {props.friend !== undefined && (
        <>
          <Name>
            {props.friend?.friend.username ?? '친구를 선택하세요.'}{' '}
            <div>인벤토리</div>
            <Waiting isWaiting={waiting}></Waiting>
          </Name>

          {testQuestionAnswerCase !== undefined &&
            testQuestionAnswerCase.id !== 0 && (
              <Factor>
                <FactorTitle>
                  {props.friend?.friend.username}님의 주요 키워드
                </FactorTitle>
                <TagContainer isExpanded={isExpanded}>
                  {testQuestionAnswerCase?.tags &&
                    JSON.parse(testQuestionAnswerCase?.tags).map(
                      (tag: string) => <Tag>{tag}</Tag>
                    )}
                </TagContainer>
                <More>
                  {isExpanded ? (
                    <SmallLightGrayButton onClick={() => setIsExpanded(false)}>
                      접기
                    </SmallLightGrayButton>
                  ) : (
                    <SmallLightGrayButton onClick={() => setIsExpanded(true)}>
                      더보기
                    </SmallLightGrayButton>
                  )}
                </More>
              </Factor>
            )}

          <Inventories>
            <>
              {inventories.length > 0 ? (
                inventories.map((inventory: Inventory, index) => (
                  <MenteeInventoryGrid
                    key={index}
                    imaegWidth={195}
                    inventory={inventory}
                    inventories={inventories}
                    //setInventories={setInventories}
                    user={props.friend?.friend ?? ({} as User)}
                    isShowRemoveInventory={false}
                  ></MenteeInventoryGrid>
                ))
              ) : (
                <NoJob>
                  친구의 인벤토리에 직업이 없습니다. 친구의 직업을 추천해주세요.
                </NoJob>
              )}
            </>
          </Inventories>
        </>
      )}
    </Container>
  )
}

const Container = styled.div`
  grid-area: main;
  margin-bottom: 1rem;
`
const Name = styled.div`
  padding-bottom: 10px;
  font-size: 1.5rem;
  font-weight: 600;
  display: flex;
  align-items: flex-end;
  column-gap: 10px;
  div {
    font-size: 1.3rem;
  }
`
const Inventories = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
  row-gap: 20px;
`

const NoJob = styled.div`
  padding: 0 20px;
`

const Factor = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 20px;
`
const FactorTitle = styled.div`
  width: 100%;
  font-size: 1.05rem;
`
const Tag = styled.div`
  background-color: orange;
  margin: 2px;
  padding: 3px 12px;
  border-radius: 10px;
`
const TagContainer = styled.div`
  max-height: 60px;
  overflow: hidden;
  position: relative;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;

  ${(props: ExpandedProps) =>
    props.isExpanded && 'max-height: 1000px; padding-bottom:10px;'}

  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 30px;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    );
  }
`
const More = styled.div`
  text-align: right;
  width: 100%;
`

export default Main
